module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/testimonial/testimonial-style6/testimonial-style6.component.scss
// module id = ./src/app/features/testimonial/testimonial-style6/testimonial-style6.component.scss
// module chunks = main